/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Your_LibraryInputs */

const en_common_your_library = /** @type {(inputs: Common_Your_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your library`)
};

const es_common_your_library = /** @type {(inputs: Common_Your_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu biblioteca`)
};

/**
* | output |
* | --- |
* | "Your library" |
*
* @param {Common_Your_LibraryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_your_library = /** @type {((inputs?: Common_Your_LibraryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Your_LibraryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_your_library(inputs)
	return en_common_your_library(inputs)
});